import { LocationUsage } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';

export const flattenLocationUsages = (usages: Record<string, LocationUsage> = {}) =>
  Object.values(usages).flatMap((location) => location.usage);
